<template>
  <q-section v-bind="$attrs" :bg-i="uiMeta.images.teamBg">
    <q-section :bg-i="myInfo?.data?.my_cp_info?.user1?.avatar_url || uiMeta.images.teamEmptyBg"
      :key="myInfo?.data?.my_cp_info?.user1?.avatar_url || uiMeta.images.teamEmptyBg"
      v-bind="uiMeta.layout.wrapper.user1Wrapper">
      <q-section v-bind="uiMeta.layout.wrapper.user1TextWrapper" class="ellipsis text-center">
        {{ myInfo?.data?.my_cp_info?.user1?.nickname }}
      </q-section>
    </q-section>
    <q-section :bg-i="myInfo?.data?.my_cp_info?.user2?.avatar_url" :key="myInfo?.data?.my_cp_info?.user2?.avatar_url"
      v-bind="uiMeta.layout.wrapper.user2Wrapper" @click="handleInviteOpen()">
      <q-section v-bind="uiMeta.layout.wrapper.user2TextWrapper" class="ellipsis text-center">
        {{ myInfo?.data?.my_cp_info?.user2?.nickname || uiMeta.config.emptyNickname }}
      </q-section>
    </q-section>
    <q-section v-bind="uiMeta.layout.wrapper.chipWrapper" class="flex items-center justify-center">
      {{ chipData }}
    </q-section>
    <q-section v-bind="uiMeta.layout.wrapper.questionIconWrapper" @click="handleCpRuleOpen()"></q-section>
    <q-section v-bind="uiMeta.layout.wrapper.taskClickWrapper" @click="handleTaskOpen()"></q-section>
    <q-section v-show="!myInfo?.data?.my_cp_info?.user2?.public_id"
      v-bind="uiMeta.layout.wrapper.teamBtnSendInviteWrapper" :bg-i="uiMeta.images.teamBtnSendInvite"
      @click="handleInviteOpen()"></q-section>

    <!-- 组队cp说明 -->
    <q-dialog :name="uiMeta.config.cpRuleDialogName" :bg-i="uiMeta.images.teamCpRuleDialog" pc="pc"></q-dialog>

    <!-- 邀请他人弹窗 -->
    <q-dialog name="inviteDialog" :bg-i="uiMeta.images.teamInviteDialog" pc="pc">
      <template #default="{ data }">
        <q-section v-if="data?.platform_cp !== null" v-bind="uiMeta.layout.wrapper.platformCpWrapper"
          class="flex items-center justify-around">
          <q-section :bg-i="data?.platform_cp.user.avatar_url"
            v-bind="uiMeta.layout.wrapper.platformCpAvatarWrapper"></q-section>
          <q-section :bg-i="data?.platform_cp.avatar_url"
            v-bind="uiMeta.layout.wrapper.platformCpAvatarWrapper"></q-section>
        </q-section>
        <q-section v-else v-bind="uiMeta.layout.wrapper.recommendCpWrapper" class="flex items-center justify-around">
          <q-section v-for="(avatar, index) in data.recommend_cps" :key="index" :bg-i="avatar.avatar_url"
            v-bind="uiMeta.layout.wrapper.recommendCpAvatarWrapper" @click="selectedCp = avatar.public_id">
            <q-section v-if="selectedCp === avatar.public_id" :bg-i="uiMeta.images.teamIconRight"
              v-bind="uiMeta.layout.wrapper.recommendCpIconRightWrapper"></q-section>
            <q-section v-bind="uiMeta.layout.wrapper.recommendCpNicknameWrapper" class="ellipsis">
              {{ avatar.nickname }}
            </q-section>
          </q-section>
        </q-section>
        <q-section v-bind="uiMeta.layout.wrapper.recommendCpInviteButtonWrapper"
          @click="inviteCpData('recommend')"></q-section>

        <q-section v-bind="uiMeta.layout.wrapper.recommendCpInputWrapper" :bg-i="uiMeta.images.teamInput">
          <q-section v-bind="uiMeta.layout.wrapper.recommendCpInputInnerWrapper">
            <input class="input" :placeholder="uiMeta.config.searchPlaceholder" v-model="searchId" />
          </q-section>
          <q-section v-bind="uiMeta.layout.wrapper.recommendCpInputSearchWrapper"
            @click="doSearchUser(searchId)"></q-section>
        </q-section>
        <q-section v-if="searchUserData !== null" v-bind="uiMeta.layout.wrapper.searchResultWrapper">
          <q-section :bg-i="searchUserData.avatar_url"
            v-bind="uiMeta.layout.wrapper.searchResultAvatarWrapper"></q-section>
          <q-section v-bind="uiMeta.layout.wrapper.searchResultNicknameWrapper" class="ws-nowrap">
            {{ searchUserData.nickname }}
          </q-section>
          <q-section v-bind="uiMeta.layout.wrapper.searchResultButtonWrapper" :bg-i="uiMeta.images.teamButtonInvite"
            @click="inviteCpData('search')"></q-section>
        </q-section>
        <q-section v-bind="uiMeta?.layout?.wrapper?.closeBtnWrapper" @click="$dialogs.inviteDialog.close()"></q-section>
      </template>
    </q-dialog>
    <!-- 被邀请弹窗 -->
    <q-dialog name="beInvitedDialog" :bg-i="uiMeta.images.teamBeInvitedBg" pc="pc">
      <template #default="{ data }">
        <q-section v-bind="uiMeta.layout.wrapper.beInvitedDialogWrapper" class="of-y-a flex flex-col">
          <q-section v-bind="uiMeta.layout.wrapper.beInvitedItemWrapper" :bg-i="uiMeta.images.teamInvitedMask"
            v-for="item in data?.inviteListData" :key="item.id">
            <q-section :bg-i="item.inviter.avatar_url"
              v-bind="uiMeta.layout.wrapper.beInvitedItemAvatarWrapper"></q-section>
            <q-section v-bind="uiMeta.layout.wrapper.beInvitedItemNicknameWrapper" class="ws-nowrap">
              {{ item.inviter.nickname }}
            </q-section>
            <q-section v-bind="uiMeta.layout.wrapper.beInvitedItemTextWrapper" class="ws-nowrap">
              {{ uiMeta.config.inviteText }}
            </q-section>
            <q-section v-bind="uiMeta.layout.wrapper.beInvitedItemButtonWrapper" :bg-i="uiMeta.images.teamButtonAgree"
              @click="acceptCpInviteData(item.invite_id)"></q-section>
          </q-section>
        </q-section>
        <q-section v-bind="uiMeta?.layout?.wrapper?.closeBtnWrapper"
          @click="$dialogs.beInvitedDialog.close()"></q-section>
      </template>
    </q-dialog>
  </q-section>
</template>

<script setup>
import { defaultConfig as uiMeta, useTeam } from './use-team'
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'
const { $dialogs } = useDialogs()

const { myInfo,
  handleInviteOpen,
  doSearchUser,
  inviteCpData,
  searchUserData,
  selectedCp,
  acceptCpInviteData,
  chipData,
  handleCpRuleOpen,
  handleTaskOpen,
} = useTeam(uiMeta)
</script>

<style scoped lang="scss">
.input {
  border: none;
  background: transparent;
  width: 100%;
  height: 100%;
  line-height: 0.68rem;
  color: rgba(141, 25, 12, 0.2);

  &::placeholder {
    line-height: 0.68rem;
    color: rgba(141, 25, 12, 0.2);
  }
}

.flex-shrink-0 {
  flex-shrink: 0;
}
</style>
